import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FiOnboardingSynchronizedService } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized.service';
import {
    IOnboardingAssignee,
    IOnboardingAssigneesItem,
} from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-onboarding-assignees-banner',
    templateUrl: './fi-onboarding-assignees-banner.component.html',
    styleUrl: './fi-onboarding-assignees-banner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-assignees-banner' },
    standalone: false,
})
export class FiOnboardingAssigneesBannerComponent implements OnInit {
    @Input({ required: true }) onboardingAssignees: IOnboardingAssigneesItem[];

    private _onboardingAssignees$ = new BehaviorSubject<IOnboardingAssigneesItem[]>([]);
    protected get onboardingAssignees$(): Observable<IOnboardingAssigneesItem[]> {
        return this._onboardingAssignees$.asObservable();
    }
    protected get hasOnboardingAssignees$(): Observable<boolean> {
        return this._onboardingAssignees$.pipe(map((items) => !!items.length));
    }

    constructor(
        private fiOnboardingSynchronizedService: FiOnboardingSynchronizedService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit(): void {
        this._onboardingAssignees$.next(this.onboardingAssignees);
        //this.loadData();
    }

    onAssignParticipantsClick(onboardingAssigneesItem: IOnboardingAssigneesItem) {
        // todo choose onboarding
        this.fiStateService.go(FiStateNames.Onboarding.AssignUsers, {
            id: onboardingAssigneesItem.OnboardingId,
            onboardingAssigneesItem: onboardingAssigneesItem,
        });
    }

    /*private loadData() {
        this.fiOnboardingSynchronizedService.getOnboardingAssignees().then((result) => {
            this._onboardingAssignees$.next(result);
        });
    }*/
}
